import React, { useState, useRef } from "react";
import ReactPlayer from "react-player";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import sliderArrow from "../icon/slider-arrow.svg";
import Spiral from "../icon/testimonial/Spiral.svg";

export const TestimonialVideoSlider = ({ items }) => {
  let sliderRef = useRef(null);
  const infiniteState = (slidesToShow) => {
    return items?.length > slidesToShow ? true : false;
  };

  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };

  // const ImgPath = process.env.REACT_APP_IMg_URL;

  const settings = {
    dots: false,
    infinite: infiniteState(3),
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 780, // mobile breakpoint
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: infiniteState(1),
          variableWidth: false,
        },
      },
      {
        breakpoint: 1200, // mobile breakpoint
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: infiniteState(2),
          variableWidth: false,
        },
      },
    ],
  };

  return (
    <div className="mt-28 sm:mt-0 w-full h-full min-h-[40vh] sm:min-h-[45vh] max-h-[550px] gap-5 items-center justify-center relative ">
      <div className="absolute img-1 -top-6 left-0">
        <img src={Spiral} alt="" />
      </div>
      <div className="absolute img-2 right-0 bottom-12">
        <img src={Spiral} alt="" />
      </div>
      <div>
        <Slider
          className="testimonial_video_slider"
          ref={(slider) => {
            sliderRef = slider;
          }}
          {...settings}
        >
          {items?.map((data) => (
            <VideoCard videoUrl={data?.link} />
          ))}
        </Slider>
      </div>
      <div className="absolute flex top-[50%] justify-between inset-0 h-[0px] bg-green-500 w-[100%] sm:w-[110%] sm:-left-[5%]">
        <button onClick={previous}>
          <img src={sliderArrow} alt="" className="w-[70px] h-[35px]" />
        </button>
        <button onClick={next}>
          <img
            src={sliderArrow}
            alt=""
            className="w-[70px] h-[35px] rotate-180"
          />
        </button>
      </div>
    </div>
  );
};

const VideoCard = ({ url, videoUrl }) => {
  return (
    <div className="relative h-[450px] sm:w-[325px] w-[90%]  flex items-center justify-center mx-auto z-10">
      <div className="bg-[#00012F] absolute rounded-3xl h-[210px] w-[240px] top-0 left-0" />
      <div className="rounded-3xl h-[420px] w-[290px] bg-blue-600 z-10 overflow-hidden">
        <ReactPlayer url={videoUrl} controls height={"100%"} width={"100%"} />
      </div>
      <div className="video-card-gradient absolute rounded-3xl h-[420px] w-[290px] bottom-0 right-0" />
    </div>
  );
};
